import React, { useEffect, useState } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import Pagination from "../General/Pagination";
import StudentPanelMenu from "./StudentPanelMenu";
import StudentRightsCheck from "./StudentRightsCheck";

const StudentPanelLibrary = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [listOfRecords, setListOfRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  document.title = "My Library Books";

  const fetchHistory = (page, size) => {
    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "Library/GetBorrowHistoryReport",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey: AccessKey,
        UserID: UserID,
        MemberType: MemberType,
        pageNo: page,
        pageSize: size,
      },
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          setListOfRecords(response.data.ListofRecords || []);
          setTotalRecords(response.data.totalRecords || 0);
        } else {
          setListOfRecords([]);
          setTotalRecords(0);
          if (response.data.status_message) {
            toast.error(response.data.status_message, { position: toast.POSITION.TOP_RIGHT });
          }
        }
        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
        toast.error("Network Error..", { position: toast.POSITION.TOP_RIGHT });
      });
  };

  useEffect(() => {
    fetchHistory(pageNo, pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNo, pageSize]);

  const renderRows = () => {
    if (listOfRecords != null && listOfRecords.length > 0) {
      let count = 1;
      return listOfRecords.map((item, index) => (
        <tr key={index}>
          <td>{count++ + pageSize * (pageNo - 1)}</td>
          <td>{item.Book_No}</td>
          <td>{item.Name_Of_Book}</td>
          <td>{item.Date_Of_Issue ? moment(item.Date_Of_Issue).format("DD/MM/YYYY") : ""}</td>
          <td>{item.Return_Date ? moment(item.Return_Date).format("DD/MM/YYYY") : ""}</td>
          <td>
            {item.Actual_Return_Date
              ? moment(item.Actual_Return_Date).format("DD/MM/YYYY")
              : "-"}
          </td>
          <td>{item.Status}</td>
          <td>{item.Fine > 0 ? item.Fine : "-"}</td>
        </tr>
      ));
    }
    return (
      <tr>
        <td colSpan="8">
          <h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>
            No library borrow history found.
          </h4>
        </td>
      </tr>
    );
  };

  return (
    <>
      <StudentRightsCheck />
      <StudentPanelMenu />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="page-title">My Library Books</div>
            </div>
            <div className="col-md-6 text-end">
              <span className="counting">{totalRecords} Records</span>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="card">
            <div className="card-body table_card">
              <table className="table table-theme table-hover">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th>Book No</th>
                    <th>Book Name</th>
                    <th>Issue Date</th>
                    <th>Due Date</th>
                    <th>Return Date</th>
                    <th>Status</th>
                    <th>Fine</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td className="text-center" colSpan="8">
                        <Spinner animation="border" role="status"></Spinner>
                      </td>
                    </tr>
                  ) : (
                    renderRows()
                  )}
                </tbody>
              </table>

              {totalRecords > pageSize && (
                <div className="pagination-wrap">
                  <Pagination
                    pageNo={pageNo}
                    pageSize={pageSize}
                    totalRecords={totalRecords}
                    onPageChange={setPageNo}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentPanelLibrary;
